module.exports = __webpack_public_path__ + "media/images/hero/hero1-house-base-cb829f12c5f36e2e7028a763d58fea07.svg";